export default __webpack_public_path__ + "static/media/img15.97d70f07.PNG";